import { Component, Inject, OnInit } from '@angular/core';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';
import { tap, takeUntil, timer } from 'rxjs';
import { HttpPodcastService } from '../../../core/services/http/http-podcast.service';
import { LanguageService } from '../../../core/services/language.service';
import { Podcast } from '../../models/entities/podcast.entity';
import { BaseComponent } from '../../components/inherited/base/base.component';

export interface ModalPodcastData {
  podcastId: string;
}

@Component({
  selector: 'app-modal-podcast',
  templateUrl: './modal-podcast.component.html',
  styleUrls: ['./modal-podcast.component.scss'],
})
export class ModalPodcastComponent extends BaseComponent implements OnInit {
  podcast: Podcast;

  constructor(
    public dialogRef: MatDialogRef<ModalPodcastComponent>,
    @Inject(MAT_DIALOG_DATA) public modalData: ModalPodcastData,
    public languageService: LanguageService,
    private httpPodcastService: HttpPodcastService
  ) {
    super();
  }

  ngOnInit(): void {
    this.httpPodcastService
      .get(this.modalData.podcastId)
      .pipe(
        tap((res) => {
          this.podcast = new Podcast(res);
        })
      )
      .subscribe(() => {
        timer(30000)
          .pipe(takeUntil(this.alive$))
          .subscribe(() => {
            this.httpPodcastService.incrementViews(this.podcast.id).subscribe();
          });
      });
  }

  close() {
    this.dialogRef.close();
  }
}
